import models from './femaProducts.json'
import { getProductPrimaryImage } from '../lib/dropify'
import type { StorefrontProduct } from '../lib/dropify'

export const FEMA_MODELS = models
export const FEMA_PATH = '/cd-fema'
export const FEMA_CATEGORY = 'CD FEMA'
export const FEMA_MESSAGE = 'Halo Dropify, saya mau kulakan CD wanita FEMA untuk stok toko. Model: ___. Jumlah: ___ lusin. Ukuran/warna: ___. Kota tujuan: ___. Bisa cek stok, minimum order, dan quotation?'

export function resolveFemaProducts(products: StorefrontProduct[]) {
  return FEMA_MODELS.map((model) => {
    const product = products.find((item) => item.sku === model.sku || item.slug === model.slug)
    return {
      ...model,
      id: product?.id ?? model.sku,
      name: product?.name ?? model.name,
      slug: product?.slug ?? model.slug,
      image: product?.photos.length
        ? getProductPrimaryImage(product, { width: 800, fitIn: true, format: 'webp', quality: 80 })
        : model.image,
    }
  })
}

export type FemaProduct = ReturnType<typeof resolveFemaProducts>[number]

export function femaProductMessage(product: FemaProduct) {
  return `Halo Dropify, saya mau cek ${product.name} untuk stok toko. Kebutuhan: ___ lusin. Ukuran/warna: ___. Kota tujuan: ___. Bisa cek stok dan quotation?`
}

export const FEMA_FAQ = [
  { q: 'Berapa minimum order celana dalam FEMA?', a: 'Acuan kategori CD dan underwear adalah 50 lusin, dengan 12 pcs per lusin. Kirim pembagian model FEMA dan jumlahnya agar admin mengonfirmasi minimum order serta ketentuan campur model sebelum quotation.' },
  { q: 'Bagaimana mendapatkan harga FEMA per lusin?', a: 'Sebutkan model 361, 362, 363, 884, atau 089/889 beserta jumlah dan ukuran. Admin memberikan harga terkini setelah memeriksa stok, lalu menghitung ongkir dari kota tujuan.' },
  { q: 'Apakah semua model FEMA memakai bahan yang sama?', a: 'Komposisi bahan perlu diperiksa per model. Minta keterangan bahan dan sample model yang Anda pilih sebelum menentukan pembelian grosir.' },
  { q: 'Apakah ukuran 3L sama untuk semua model?', a: 'Bandingkan ukuran dalam sentimeter per model. FEMA 884 memakai penamaan XXL (3L), sementara model 361, 362, dan 089/889 memakai 3L. Minta admin mencocokkan label dan ukuran barang yang akan dikirim.' },
  { q: 'Bagaimana pembayaran pesanan FEMA?', a: 'Pastikan model, jumlah, ukuran, harga, dan ongkir sudah disepakati dengan admin sebelum membayar. Setelah pembayaran dikonfirmasi, admin memberi informasi penyiapan dan pengiriman. Dropify tidak melayani COD.' },
]

export const FEMA_TRUST_QUESTIONS = [
  { q: 'Bisa cek stok 361 dan 363 sebelum memilih?', a: 'Bisa. Kirim kebutuhan per model dan ukuran. Admin memeriksa stok kedua model agar Anda dapat membandingkan ban pinggang serta detail tepi kaki sebelum mengunci pesanan.' },
  { q: 'Bagaimana memesan motif kupu-kupu dengan kode 089/889?', a: 'Sebutkan FEMA 089/889 butterfly timbul atau kirim gambar model tersebut. Minta admin memastikan kode pada label, ukuran, dan warna barang yang tersedia.' },
  { q: 'Bisakah warna FEMA dicampur dalam satu lusin?', a: 'Kirim susunan warna yang dibutuhkan per model. Admin mengonfirmasi komposisi kemasan dan apakah pilihan tersebut dapat dipenuhi sebelum order diproses.' },
  { q: 'Bisa meminta sample FEMA 884 dan 089/889?', a: 'Tanyakan ketersediaan sample kedua model untuk membandingkan motif bunga dan kupu-kupu timbul. Biaya sample dihitung dari harga satuan ditambah ongkir.' },
  { q: 'Bagaimana jika perlu ratusan lusin FEMA untuk toko di luar Surabaya?', a: 'Kirim jumlah per model, pembagian ukuran, kota tujuan, dan target penerimaan. Admin mengecek kemampuan pemenuhan, lalu mengonfirmasi waktu penyiapan, ongkir, dan estimasi perjalanan ekspedisi.' },
]
